import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";

export default function Navbar(props) {
    // Timer states
    const [time, setTime] = useState(20 * 60); // Default to 20 minutes (in seconds)
    const [isRunning, setIsRunning] = useState(false);

    // Timer effect
    useEffect(() => {
        let timer = null;
        if (isRunning && time > 0) {
            timer = setInterval(() => {
                setTime(prevTime => prevTime - 1);
            }, 1000);
        } else if (time === 0 && isRunning) {
            clearInterval(timer);
            alert('Timer is over!');
            setIsRunning(false); // stop the timer once it's over
        }
        return () => clearInterval(timer);
    }, [time, isRunning]);

    // Handle start/pause
    const handleStartPause = () => {
        if (time > 0) {
            setIsRunning(!isRunning);
        }
    };

    // Handle reset
    const handleReset = () => {
        setIsRunning(false);
        setTime(20 * 60); // Reset to default 20 minutes
    };

    // Increase/decrease time in minutes
    const handleIncrease = () => {
        if (!isRunning) {
            setTime(time + 60);
        }
    };

    const handleDecrease = () => {
        if (!isRunning && time >= 60) {
            setTime(time - 60);
        }
    };

    return (
        <nav className={`navbar navbar-expand-lg navbar-${props.mode} bg-${props.mode}`}>
            <div className="container-fluid">
                <Link className="navbar-brand" to="/">{props.title}</Link>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                        <li className="nav-item">
                            <Link className="nav-link" aria-current="page" to="/">Home</Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link" to="/about">{props.aboutText}</Link>
                        </li>
                    </ul>

                    {/* Centered Timer Section */}
                    <div className="d-flex justify-content-center align-items-center mx-auto">
                        <button className="btn btn-secondary me-1" onClick={handleDecrease} disabled={isRunning}>-</button>
                        <span>{Math.floor(time / 60)}:{time % 60 < 10 ? `0${time % 60}` : time % 60}</span>
                        <button className="btn btn-secondary ms-1" onClick={handleIncrease} disabled={isRunning}>+</button>
                        <button className="btn btn-primary ms-3" onClick={handleStartPause}>
                            {isRunning ? 'Pause' : 'Start'}
                        </button>
                        <button className="btn btn-danger ms-1" onClick={handleReset}>Reset</button>
                    </div>

                    <div className={`form-check form-switch text-${props.mode === 'light' ? 'dark' : 'light'} ms-auto`}>
                        <input className="form-check-input" onClick={props.toggleMode} type="checkbox" id="flexSwitchCheckDefault" />
                        <label className="form-check-label" htmlFor="flexSwitchCheckDefault">Enable Dark Mode</label>
                    </div>
                </div>
            </div>
        </nav>
    );
}

// Prop Type Checking
Navbar.propTypes = {
    title: PropTypes.string.isRequired,
    aboutText: PropTypes.string
}

// Setting Default Props if not passed
Navbar.defaultProps = {
    title: "Title Here...",
    aboutText: "About"
}
